module.exports = __webpack_public_path__ + "sansg/img/10.88e585da.png";